import { useState } from 'react';

export const useInputErrors = () => {
  const [errors, setErrors] = useState({});

  const updateErrors = (errorsForm) => {
    setErrors((state) => ({
      ...state,
      ...errorsForm,
    }));

    return false;
  };

  const resetErrors = () => {
    setErrors({});
    return true;
  };

  return {
    errors,
    setErrors,
    resetErrors,
    updateErrors,
  };
};
